import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  background-image: url(${props => props.backgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Panel = styled.div`
  width: 100%;
  height: 100%;
  /* background: rgba(0, 0, 0, 0.5); */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const AppInfoContainer = styled.div`
 // height: 200px;
 padding: 50px 0px;
  text-align: center;
  color: white;
  & > h2 {
    color: white;
  }
`; 